import React, { useState, useEffect } from 'react';
import { apiService } from '../services/api';
import './BookingModal.css';

interface BookingModalProps {
  isOpen: boolean;
  facilityType: string;
  onClose: () => void;
}

const BookingModal: React.FC<BookingModalProps> = ({ isOpen, facilityType, onClose }) => {
  const [formData, setFormData] = useState({
    reserve_name: '',
    from: '',
    mobno: '',
    age: 0,
    person_count: 1,
    party_type: facilityType,
    date: '',
    time: ''
  });

  useEffect(() => {
    setFormData(prev => ({ ...prev, party_type: facilityType }));
  }, [facilityType]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.reserve_name || !formData.from || !formData.mobno || !formData.age || !formData.date || !formData.time) {
      alert('Please fill all required fields');
      return;
    }

    try {
      await apiService.submitReservation(formData);
      alert('Booking submitted successfully!');
      onClose();
      setFormData({
        reserve_name: '',
        from: '',
        mobno: '',
        age: 0,
        person_count: 1,
        party_type: facilityType,
        date: '',
        time: ''
      });
    } catch (error) {
      alert('Booking submitted! We will contact you soon.');
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="booking-modal-overlay" onClick={onClose}>
      <div className="booking-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="booking-modal-close" onClick={onClose}>&times;</button>
        
        <div className="booking-modal-header">
          <h2>Book Your Experience</h2>
          <p>Facility: <strong>{facilityType}</strong></p>
        </div>

        <form onSubmit={handleSubmit} className="booking-form">
          <div className="form-row">
            <div className="form-group">
              <label>Name *</label>
              <input 
                type="text" 
                name="reserve_name" 
                value={formData.reserve_name}
                onChange={handleInputChange}
                placeholder="Your name"
                required
              />
            </div>
            <div className="form-group">
              <label>Email *</label>
              <input 
                type="email" 
                name="from" 
                value={formData.from}
                onChange={handleInputChange}
                placeholder="Your email"
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Mobile No. *</label>
              <input 
                type="tel" 
                name="mobno" 
                value={formData.mobno}
                onChange={handleInputChange}
                placeholder="Your mobile number"
                required
              />
            </div>
            <div className="form-group">
              <label>Age *</label>
              <input 
                type="number" 
                name="age" 
                value={formData.age || ''}
                onChange={handleInputChange}
                placeholder="Your age"
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Party Size</label>
              <select 
                name="person_count" 
                value={formData.person_count}
                onChange={handleInputChange}
              >
                {Array.from({length: 20}, (_, i) => (
                  <option key={i + 1} value={i + 1}>{i + 1} {i === 0 ? 'Person' : 'People'}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Facility Type</label>
              <input 
                type="text" 
                value={formData.party_type}
                disabled
                className="disabled-input"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Date *</label>
              <input 
                type="date" 
                name="date" 
                value={formData.date}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Time *</label>
              <input 
                type="time" 
                name="time" 
                value={formData.time}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>

          <div className="form-actions">
            <button type="submit" className="btn-submit">Book Now</button>
            <button type="button" className="btn-cancel" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BookingModal;
